import RoutesList from 'config/constants';
import ContextProvider from 'contexts/ContextProvider';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import HomePage from './pages/home-page';
import ItemDetailPage from './pages/item-detail-page';

function App() {
  return (
    <ContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path={RoutesList.LANDING_PAGE} element={<HomePage />} />
          <Route path={RoutesList.ITEM_DETAIL_PAGE} element={<ItemDetailPage />} />
        </Routes>
      </BrowserRouter>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </ContextProvider>
  );
}

export default App;
